export default "__VITE_ASSET__c267844e__"